export default __webpack_public_path__ + "static/million-back-c6d4bbcf7a2c438aa937914e818e5f79.webp";